import styled from "@emotion/styled";
import DrawerMenu from "../appbar";
import AppbarMenuItems from "../appbar/menuItems";
import React from "react";
import Footer from "../footer";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  overflow:auto;
  max-height:100vh;
`;
const ContentContainer = styled.div`
  transition: all 0.3s;
  position: relative;
  top: 0;
  height: 76%;
  width: 100%;
`;

const MainFrame = (Component: Function, menuItems?: React.ReactNode) => (props: any) => {
    return (
        <Container>
            <ContentContainer>
                <DrawerMenu menuItems={menuItems}>
                    <Component {...props} />
                </DrawerMenu>
                <Footer />
            </ContentContainer>
        </Container>
    );
};

export default MainFrame;
